<template>
  <section class="ecology_4">
    <div class="ecology_content_4">
      <h5 class="ecology_title_4">
        <div class="title_content">应用生态</div>
      </h5>

      <div class="content_4">
        <div class="font_box_4">
          <h6 class="font_title_4">丰富的应用内容</h6>
          <h3 class="font_title2_4">精选优质 CP<br />覆盖全车核心场景</h3>
        </div>
        <div
          bg-url="@/plan/assets/image/4/logo.jpg"
          v-bg
          class="logo_bg_4"
        ></div>
      </div>

      <div class="content_4">
        <div class="font_box_4">
          <h6 class="font_title_4">打造专属的应用商店</h6>
          <h3 class="font_title2_4">页面样式自由组合<br />提供闭环运营能力</h3>
        </div>
        <div
          bg-url="@/plan/assets/image/4/shopping.jpg"
          v-bg
          class="content_shopping_4"
        ></div>
      </div>

      <h5 class="ecology_title_4">
        <div class="title_content game_title">游戏生态</div>
      </h5>
      <div class="content_4 game_box">
        <div class="game_title_4">
          <h6>多端游戏持续引入</h6>
        </div>

        <div
          class="game_box_4"
          bg-url="@/plan/assets/image/4/game.png"
          v-bg
        ></div>
      </div>

      <div class="hardware_game_4">
        <div
          class="game_content_4"
          bg-url="@/plan/assets/image/4/hardware_game.jpg"
          v-bg
        >
          <div class="game_font_4">
            <h6>按需定制游戏，主力打造全方位沉浸的游戏体验</h6>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Ecology',
}
</script>

<style lang="less" scoped>
.ecology_4 {
  height: 3168px;
  background-color: #f7f8fa;
}
.ecology_content_4 {
  width: 1200px;
  margin: auto;
}
.ecology_title_4 {
  padding: 100px 0 50px 0;

  .title_content {
    font-weight: 700;
    font-size: 46px;
    line-height: 65px;

    background: linear-gradient(85.31deg, #32b5ff -1.29%, #237dff 99.49%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;

    &.game_title {
      background: linear-gradient(266.23deg, #5465ff -3.32%, #926bff 98.55%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
  }
}

.content_4 {
  width: 100%;
  height: 624px;
  border-radius: 30px;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  display: flex;
  margin-bottom: 24px;

  .logo_bg_4 {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 640px;
    background-size: 100% 100%;
  }

  .content_shopping_4 {
    position: absolute;
    right: 0;
    top: 0;
    width: 640px;
    height: 100%;
    background-size: 100%;
  }

  &.game_box {
    height: 590px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    position: relative;
  }
}

.game_title_4 {
  position: absolute;
  top: 40px;
  left: 40px;

  h6 {
    font-weight: 700;
    font-size: 26px;
    line-height: 37px;
    color: #000000;
  }
}

.game_box_4 {
  width: 100%;
  height: 590px;
  background-size: 100%;
}

.font_box_4 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 120px;
}

.font_title_4 {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;

  background: linear-gradient(85.31deg, #32b5ff -1.29%, #237dff 99.49%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.font_title2_4 {
  font-weight: 700;
  font-size: 46px;
  line-height: 65px;

  color: #000000;
}

.hardware_game_4 {
  height: 720px;
  width: 1200px;
  display: flex;
}

.game_content_4 {
  width: 1200px;
  height: 100%;
  background: #fff;
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  background-size: 100% 100%;
}

.game_font_4 {
  position: absolute;
  top: 40px;
  left: 40px;

  h6 {
    font-weight: 700;
    font-size: 26px;
    line-height: 37px;
    color: #ffffff;
    margin: 0;
  }
}
</style>
